import { render } from "./ExampleComponent.vue?vue&type=template&id=5eae5f87"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/ExampleComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5eae5f87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5eae5f87', __exports__)) {
    api.reload('5eae5f87', __exports__)
  }
  
  module.hot.accept("./ExampleComponent.vue?vue&type=template&id=5eae5f87", () => {
    api.rerender('5eae5f87', render)
  })

}


export default __exports__